/**
 * iOS: Modal without supportedOrientations can force portrait when presenting from landscape.
 * Use on React Native `Modal` and `react-native-modal` for consistent tablet/landscape behavior.
 */
export const MODAL_SUPPORTED_ORIENTATIONS = [
  'portrait',
  'landscape',
  'landscape-left',
  'landscape-right',
  'portrait-upside-down',
] as const;
